module.exports = __webpack_public_path__ + "static/media/logo_brutal.91b004c7.svg";